module.exports = __webpack_public_path__ + "img/vr.da22c275.svg";